"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _ = require("../../");

var _molecules = require("../../molecules");

var _helpers = require("../../util/helpers");

require("./PreviewCard.css");

var _MomentPreview = require("../MomentPreview");

var _DropdownMenu = require("../../molecules/DropdownMenu");

var _RoundButton = require("../../molecules/RoundButton");

var _Toaster = _interopRequireDefault(require("../../molecules/Toaster"));

var _traceLogoWhite = _interopRequireDefault(require("../../assets/img/trace-logo-white.svg"));

var _MaxLoopOverlay = _interopRequireDefault(require("../MaxLoopOverlay"));

var _UseKeyPress = require("../../util/UseKeyPress");

var _Util = require("../../Util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PreviewCard = function PreviewCard(_ref) {
  var open = _ref.open,
      onMomentClick = _ref.onMomentClick,
      changeCard = _ref.changeCard,
      closePreview = _ref.closePreview,
      onPreviewClose = _ref.onPreviewClose,
      item = _ref.item,
      children = _ref.children,
      userId = _ref.userId,
      onShareClicked = _ref.onShareClicked,
      copyLink = _ref.copyLink,
      download = _ref.download,
      facebook = _ref.facebook,
      twitter = _ref.twitter,
      sendEmail = _ref.sendEmail,
      thisMoment = _ref.thisMoment,
      thisGame = _ref.thisGame,
      goToTraceId = _ref.goToTraceId,
      className = _ref.className,
      showAvatars = _ref.showAvatars,
      showTeamTitle = _ref.showTeamTitle,
      showPlayerNames = _ref.showPlayerNames,
      traceIdButton = _ref.traceIdButton,
      showAddToTraceId = _ref.showAddToTraceId,
      momentAdded = _ref.momentAdded,
      showShareButton = _ref.showShareButton,
      showSmallShareButton = _ref.showSmallShareButton,
      showShadeCloseButton = _ref.showShadeCloseButton,
      showAddToTraceIdButton = _ref.showAddToTraceIdButton,
      onAddToTraceIDClick = _ref.onAddToTraceIDClick,
      _ref$maxLoopCount = _ref.maxLoopCount,
      maxLoopCount = _ref$maxLoopCount === void 0 ? 5 : _ref$maxLoopCount,
      trackingAction = _ref.trackingAction;
  var childRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      noOfLoops = _useState2[0],
      setNoOfLoops = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPlaying = _useState4[0],
      setIsPlaying = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      message = _useState6[0],
      setMessage = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      showPlayIcon = _useState8[0],
      setShowPlayIcon = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showChip = _useState10[0],
      setShowChip = _useState10[1];

  var leftArrow = (0, _UseKeyPress.useKeyPress)("ArrowLeft");
  var rightArrow = (0, _UseKeyPress.useKeyPress)("ArrowRight");
  var escape = (0, _UseKeyPress.useKeyPress)("Escape");
  var space = (0, _UseKeyPress.useKeyPress)(" ");
  var moment = item ? {
    meta: {
      home_team: {
        id: item.home_team.name
      }
    },
    parent_ref_id: item.parent_ref_id,
    game_id: item.game_id,
    game_clip_id: item.game_clip_id,
    dynamic_hls: item.dynamic_hls
  } : null;
  var shareOptions = [{
    title: "Copy link",
    value: copyLink,
    iconType: _atoms.Icon.Type.Link
  }, {
    title: "Download",
    value: download,
    iconType: _atoms.Icon.Type.Download
  }, {
    title: "Facebook",
    value: facebook,
    iconType: _atoms.Icon.Type.Facebook
  }, {
    title: "Twitter",
    value: twitter,
    iconType: _atoms.Icon.Type.Twitter
  }, {
    title: "Email",
    value: sendEmail,
    iconType: _atoms.Icon.Type.Email
  }];
  var gameOptions = [{
    title: "View this moment",
    value: thisMoment,
    iconType: _atoms.Icon.Type.Moment
  }, {
    title: "Explore this game",
    value: thisGame,
    iconType: _atoms.Icon.Type.Games
  }];

  if (open) {
    (0, _Util.addClassName)(document.body, "locked");
  }

  (0, _react.useEffect)(function () {
    if (leftArrow && changeCard) {
      changeCard("back");
    }
  }, [leftArrow, changeCard]);
  (0, _react.useEffect)(function () {
    if (rightArrow && changeCard) {
      changeCard("forward");
    }
  }, [rightArrow, changeCard]);
  (0, _react.useEffect)(function () {
    if (escape) {
      closePreviewModal();

      if (closePreview) {
        closePreview();
      }
    }
  }, [escape, closePreview, closePreviewModal]);
  (0, _react.useEffect)(function () {
    if (space) {
      setIsPlaying(!isPlaying);
      setShowPlayIcon(false);
    }
  }, [space, setIsPlaying, setShowPlayIcon]);
  (0, _react.useEffect)(function () {
    message && setMessage(isPlaying ? "Play" : "Paused");
  }, [isPlaying]);
  (0, _react.useEffect)(function () {
    if (isPlaying && message) {
      childRef.current.continue();
    } else if (isPlaying && !message) {
      childRef.current.play();
      setMessage("Play");
    } else {
      if (childRef && childRef.current) {
        childRef.current.pause();
      }
    }
  }, [isPlaying, message]);

  var _onClick = function onClick(e) {
    if (onMomentClick) onMomentClick(e);
    setShowPlayIcon(false);
    setIsPlaying(!isPlaying);
  };

  var closePreviewModal = function closePreviewModal() {
    if (onPreviewClose) onPreviewClose();
    childRef.current.stop();
    setMessage("");
    setIsPlaying(false);
    setShowChip(false);
    (0, _Util.removeClassName)(document.body, "locked");
  };

  var play = function play() {
    childRef.current.play();
  };

  var _stop = function stop() {
    childRef.current.stop();
  };

  var onChange = function onChange(e, value) {
    value(e);
  };

  var changeLoopCount = function changeLoopCount(loopCount) {
    setNoOfLoops(loopCount);
    noOfLoops === maxLoopCount && _stop();
  };

  var shadeIcon = showShadeCloseButton ? _atoms.Icon.Type.Close : null;
  var traceIdIcon = moment && moment.parent_ref_id ? _atoms.Icon.Type.TraceIDFilled : _atoms.Icon.Type.TraceIDEmpty;
  var traceIdText = moment && moment.parent_ref_id ? "View in Trace iD" : "Add to Trace iD"; // Combine the parent event with its sources into a single list

  var allMomentSources = moment !== null && moment !== void 0 && moment.sources ? [moment].concat(_toConsumableArray(moment.sources)) : [moment];
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "preview-card ".concat(className ? className : "", " ").concat(open ? "open" : ""),
    key: "key-".concat(item === null || item === void 0 ? void 0 : item.game_clip_id)
  }, /*#__PURE__*/_react.default.createElement(_.Shade, {
    onClick: function onClick() {
      return closePreviewModal();
    },
    iconClassName: "shadow-close-icon",
    icon: shadeIcon,
    iconColor: _atoms.Color.White2,
    iconSize: 18
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "moment-preview-container",
    onClick: function onClick() {
      return setShowChip(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "user-data-column",
    alignItems: "center",
    spanXS: "8",
    spanMD: "4",
    spanLG: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "user-data-wrapper",
    alignItems: "flex-start",
    spacing: "4"
  }, showAvatars && (0, _helpers.renderMultipleAvatars)(item), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    bold: true,
    marginTop: "1",
    marginBottom: "1",
    color: _atoms.Color.Black,
    className: "moment-players"
  }, showPlayerNames && (0, _helpers.formatNamesOfAllPlayers)(item), " "), showTeamTitle && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    regular: true,
    content: item.home_team.title,
    color: "grey2-color",
    className: "big-moment-text"
  }), children), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "share-preview"
  }, showAddToTraceIdButton && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    span: "10"
  }, /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    title: "Add to TraceiD",
    menuPortal: "#modal-root",
    options: shareOptions,
    onChange: onChange,
    menuDirection: "right",
    offsetAxisX: 16,
    classNameMenu: "add-to-traceid",
    button: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      trkAction: "Add to TraceiD Pressed",
      alignItems: "center",
      justifyContent: "center",
      className: "Button primary preview-share-button",
      onClick: function onClick(e) {
        onAddToTraceIDClick(e);
      }
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      color: _atoms.Color.TraceTint2,
      type: traceIdIcon
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: traceIdText,
      marginLeft: "2"
    }))
  })), showAddToTraceId && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    span: "10"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    trkAction: "Notifications Preview ".concat(!momentAdded ? "Add to Trace iD" : "View my Profile", " Pressed"),
    alignItems: "center",
    justifyContent: "center",
    className: "Button preview-share-button ".concat(!momentAdded ? " primary" : ""),
    onClick: function onClick(e) {
      onAddToTraceIDClick(e);
    }
  }, !momentAdded && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: 16,
    color: _atoms.Color.TraceTint2,
    type: _atoms.Icon.Type.TraceIDEmpty
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.InnerButton,
    content: !momentAdded ? "Save" : "View",
    marginLeft: "2"
  }))), showSmallShareButton && /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    title: "Share",
    menuPortal: "#modal-root",
    options: shareOptions,
    onChange: onChange,
    menuDirection: "right",
    offsetAxisX: 16,
    classNameMenu: "small-share-button-dropdown",
    button: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      trkAction: "Share Pressed",
      alignItems: "center",
      justifyContent: "center",
      onClick: function onClick(e) {
        onShareClicked(e);
        setShowChip(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_RoundButton.RoundButton, {
      height: 56,
      width: 56,
      borderColor: "trace-tint2-color",
      color: _atoms.Color.Trace,
      icon: _atoms.Icon.Type.Action,
      iconColor: _atoms.Color.Trace,
      marginLeft: 2
    }))
  })), showShareButton && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    span: "10"
  }, /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    title: "Share",
    menuPortal: "#modal-root",
    options: shareOptions,
    onChange: onChange,
    menuDirection: "right",
    offsetAxisX: 16,
    classNameMenu: "share-button-dropdown",
    button: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      trkAction: "Share Pressed",
      alignItems: "center",
      justifyContent: "center",
      className: "Button primary preview-share-button",
      onClick: function onClick(e) {
        onShareClicked(e);
        setShowChip(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.Action
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: "Share",
      marginLeft: "2"
    }))
  })), traceIdButton && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "trace-id-button"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Go To Trace ID Pressed",
    iconSize: 24,
    size: 56,
    color: _atoms.Color.Trace,
    icon: _atoms.Icon.Type.TraceId,
    marginLeft: "2",
    span: "2",
    onClick: function onClick() {
      return goToTraceId();
    }
  })))), (moment === null || moment === void 0 ? void 0 : moment.dynamic_hls) && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    spanMD: "8",
    spanLG: "8",
    onClick: function onClick(e) {
      return _onClick(e);
    },
    className: "moment-preview-content-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "moment-preview-content"
  }, showPlayIcon && /*#__PURE__*/_react.default.createElement(_RoundButton.RoundButton, {
    trkAction: "Play Pressed",
    iconSize: 24,
    size: 56,
    icon: _atoms.Icon.Type.Play,
    marginRight: "2",
    marginLeft: "2",
    borderColor: _atoms.Color.Transparent,
    className: "play-button"
  }), /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    menuPortal: "#modal-root",
    options: gameOptions,
    title: "Go to game",
    onChange: onChange,
    classNameMenu: "go-to-game-dropdown-menu",
    menuDirection: "top",
    offsetAxisX: (0, _helpers.isSmallScreen)() ? -16 : -12,
    offsetAxisY: 16,
    buttonWidth: 200,
    buttonHeight: 40,
    button: /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
      trkAction: "GoToGameChip Pressed",
      background: _atoms.Color.Black,
      color: _atoms.Color.White2,
      marginLeft: "4",
      marginBottom: "4",
      className: "Chip full-game ".concat(showChip ? "show-chip" : ""),
      onClick: function onClick() {
        return setShowChip(true);
      },
      fat: true,
      content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
        size: 16,
        type: _atoms.Icon.Type.Leave
      }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
        color: _atoms.Color.White2,
        content: "Go to game",
        marginLeft: "2",
        marginRight: "2"
      }))
    })
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "preview"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "video-preview"
  }, moment && /*#__PURE__*/_react.default.createElement(_MomentPreview.MomentPreview, {
    ref: childRef,
    event: moment,
    sources: allMomentSources,
    playbackRate: 1,
    noHoverPlay: true,
    userId: userId,
    changeLoopCount: changeLoopCount,
    showProgressBar: true,
    trackingAction: trackingAction,
    trackingPlayerType: "Modal"
  }), /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
    background: _atoms.Color.Black,
    color: _atoms.Color.White2,
    margin: "4",
    className: "Chip close-icon",
    onClick: function onClick() {
      return closePreviewModal();
    },
    content: /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.Close
    }))
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _traceLogoWhite.default,
    alt: "logo",
    className: "logo"
  }))), message && /*#__PURE__*/_react.default.createElement(_Toaster.default, {
    key: "key-" + message,
    message: message
  }), /*#__PURE__*/_react.default.createElement(_MaxLoopOverlay.default, {
    maxLoopCount: maxLoopCount,
    loopCount: noOfLoops,
    playPressed: function playPressed() {
      return play();
    },
    goToGame: function goToGame() {
      return thisMoment();
    },
    stop: function stop() {
      return _stop();
    },
    className: "preview-card-max-loop-overlay"
  }, /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    title: "Max Loop Overlay",
    options: gameOptions,
    menuDirection: "bottom",
    menuPortal: "#modal-root",
    onChange: onChange,
    classNameMenu: "max-loop-overlay-dropdown",
    buttonWidth: "auto",
    menuPosition: "bottom"
    /* Offset 12px is half of the margin 24px to center button with dropdown */
    ,
    offsetAxisX: 12,
    button: /*#__PURE__*/_react.default.createElement(_molecules.Button, {
      trkAction: "Go To Game Pressed",
      icon: _atoms.Icon.Type.Leave,
      content: "Go\xA0to\xA0game",
      marginLeft: "6"
    })
  }))))));
};

exports.PreviewCard = PreviewCard;
PreviewCard.defaultProps = {
  showAvatars: true,
  showTeamTitle: true,
  traceIdButton: false,
  showAddToTraceId: false,
  momentAdded: false,
  showPlayerNames: true,
  showShareButton: true,
  showSmallShareButton: false,
  showAddToTraceIdButton: false,
  showShadeCloseButton: true
};